import React from 'react';
import { ToastTypes, ICardsMap, CardPosition } from 'types';

import { Wrapper, CardInfoStatus } from './styles';
import { Alert } from '../Alert';
import { ListCards } from './ListCards';

export interface IProps {
  cards: ICardsMap;
  hasUndefinedCard: boolean;
  winner: string | null;
  activeSlot?: CardPosition | null;
}

export const ClassicBaccaratResult = ({ cards, hasUndefinedCard, winner, activeSlot }: IProps) => (
  <Wrapper>
    <ListCards
      cards={cards}
      winner={winner}
      activeSlot={activeSlot}
      hasUndefinedCard={hasUndefinedCard}
    />
    <CardInfoStatus>
      {hasUndefinedCard && (
        <Alert variant={ToastTypes.ERROR} showIcon>
          Undefined
        </Alert>
      )}
    </CardInfoStatus>
  </Wrapper>
);
